import NavBar from "../components/NavBar";

function FAQ() {
  return (
    <div className="min-h-screen">
      <NavBar></NavBar>
      <div className="mx-auto px-8 py-16 flex flex-col items-center">
        <h1 className="text-4xl mb-16">Frequently Asked Questions</h1>
        <div className="bg-gray-100 rounded-lg shadow-sm max-w-4xl">
          <div className="px-8 py-12 flex flex-col items-start gap-4">
            <h1 className="text-2xl font-semibold text-gray-900 mb-3 text-center">
              About Consent Talk
            </h1>
            <h2 className="font-semibold">What is consent talk?</h2>
            <p className="">
              Consent Talk is a free tool designed to help you and your
              partner(s) have open, honest conversations about sexual activities
              and boundaries. Our “Yes List” quiz helps you discover mutual
              interests in a safe, judgment-free way.
            </p>
            <h2 className="font-semibold">How does it work?</h2>
            <p>
              Each person goes through a list of activities and checks the ones
              they're interested in or open to trying. After everyone completes
              the quiz, you'll see only the activities where there's mutual
              interest. It's that simple!
            </p>
            <h2 className="font-semibold">Who is this for?</h2>
            <p>
              Anyone who wants to communicate more openly with their sexual
              partner(s). Whether you're in a new relationship, a long-term
              partnership or just want to improve communication, this tool is
              for you.
            </p>
          </div>
        </div>

        <div className="bg-gray-100 rounded-lg shadow-sm max-w-4xl mt-16">
          <div className="px-8 py-12 flex flex-col items-start gap-4">
            <h1 className="text-2xl font-semibold text-gray-900 mb-3 text-center">
              Privacy & Security
            </h1>
            <h2 className="font-semibold">
              Is my information stored anywhere?
            </h2>
            <p className="">
              No. Everything happens directly in your browser. We don't collect,
              store, or transmit any of your responses to our servers. When you
              close the page, your data is gone.
            </p>
          </div>
        </div>

        <div className="bg-gray-100 rounded-lg shadow-sm w-full max-w-4xl mt-16">
          <div className="px-8 py-12 flex flex-col items-start gap-4">
            <h1 className="text-2xl font-semibold text-gray-900 mb-3 text-center">
              Additional Resources
            </h1>
            <h2 className="font-semibold">Learn More About Consent</h2>
            <p className="">A site about consent</p>
            <p className="">A site about consent</p>
            <p className="">A site about consent</p>

            <h2 className="font-semibold">Other Resources</h2>
            <p className="">A site about consent</p>
            <p className="">A site about consent</p>
            <p className="">A site about consent</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
